import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './languages/en.json';
import hu from './languages/hu.json';

Vue.use(VueI18n);

const locale = window.location.href.indexOf("/hu/") > -1 ? 'hu' : 'en';

const messages = {
  en,
  hu
};

const i18n = new VueI18n({
  locale,
  messages,
});

export default i18n;
